import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.software-license-management.list', {
        url: '/list',
        component: 'softwareLicenseManagementList',
    });
}





// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/list/software-license-management.list.state.js